import React from "react";
import { ProgressBar } from "primereact/progressbar";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const CardTraining = (props) => {
  const valueTemplate = (value) => {
    return (
      <React.Fragment>
        {value}
        <b>% Concluído</b>
      </React.Fragment>
    );
  };
  return (
    <div className="col-xl-6 my-2 image-training">
      {props.disabled ? (
        <div className="cardFrequently disabled-overlay" onClick={() => toast.warning("Treinamento em Desenvolvimento")}>
          <img
            style={{ width: "100%", opacity: 0.5, borderRadius: "20px" }}
            src={props.image}
            alt="trainament"
          />
        </div>
      ) : (
        <Link to={props.navigate}>
          <div className="cardFrequently">
            {props.progressValue === 0 || props.progressValue === "0" ? (
              <>
                <i style={{ zIndex: 1000 }} className="fa fa-play play-btn"></i>
                <img
                  style={{ width: "100%" }}
                  src={props.image}
                  alt="trainament"
                />
              </>
            ) : (
              <>
                <i style={{ zIndex: 1000 }} className="fa fa-play play-btn"></i>
                <img
                  style={{ width: "100%" }}
                  src={props.image}
                  alt="trainament"
                />
              </>
            )}
          </div>
          <div className="col-md-12 bg-white d-flex flex-column justify-content-center progress-card">
            <div className="col-md-12 d-flex justify-content-center mt-3">
              <ProgressBar
                style={{ height: "15px", fontSize: "12px", width: "85%" }}
                color="#00ADD7"
                value={props.progressValue}
                displayValueTemplate={valueTemplate}
              ></ProgressBar>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
};

export default CardTraining;
